import { render, staticRenderFns } from "./CustomerDetailsCardTravelTimes.vue?vue&type=template&id=74d233ce&scoped=true&"
import script from "./CustomerDetailsCardTravelTimes.vue?vue&type=script&lang=ts&"
export * from "./CustomerDetailsCardTravelTimes.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerDetailsCardTravelTimes.vue?vue&type=style&index=0&id=74d233ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d233ce",
  null
  
)

export default component.exports